import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getAdjustmentsById } from 'apis/projects.api';

const useGetAdjustmentsById = (id, conds = {}) => {
  const { data: adjustmentData, ...rest } = useQuery(
    ['projectAdjustment', id],
    () => getAdjustmentsById(id),
    {
      ...conds,
    }
  );

  const adjustments = useMemo(() => adjustmentData?.data ?? {}, [adjustmentData]);

  return {
    data: adjustments,
    ...rest,
  };
};

export default useGetAdjustmentsById;
